<template>
  <div class="checkbox-container">
    <input
      v-model="check"
      type="checkbox"
      :id="id"
      class="resolved-checkbox-modal"
    />
    <label :for="id">
      I accept all the <a target="_terms" href="/terms">terms and conditions</a>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    id: [String],
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      check: this.checked,
    };
  },

  watch: {
    checked: function() {
      this.check = this.checked;
      //    this.$emit("checkChanged", v);
    },
    check: function(v) {
      //this.checked = this.check
      this.$emit("checkChanged", v);
    },
  },
};
</script>

<style scoped>
.resolved-checkbox-modal {
  opacity: 0;
  position: absolute;
}

.checkbox-container {
  display: flex;

  min-width: 250px;
  margin-left: 8px;
  justify-content: flex-start;

  margin-top: 16px;
}

.checkbox-container > label {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 12px;
  font-family: "OpenSans-Bold";
}

.checkbox-container > label > a {
  margin-left: 3px;
}

.resolved-checkbox-modal + label:before {
  content: "\2714";
  border-radius: 4px;
  border: 3px solid #eddb51;
  padding: 0.8px 0.9px;
  height: 10px;
  width: 10px;
  display: inline-block;
  padding-left: 0.1em;
  padding-bottom: 0.1em;
  color: transparent;
  transition: 0.1s;
  margin-right: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}

.resolved-checkbox-modal + label:active:before {
  transform: scale(0);
}

.resolved-checkbox-modal:checked + label:before {
  background-color: #eddb51;
  color: #000;
  padding-bottom: 0.1em;
}
</style>
